// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"f774c5d3","563":"1282b757","778":"ce6ff2dd","787":"ae933a43","942":"dbb3280f"}[chunkId] + ".chunk.js";
};